import { createRouter, createWebHistory } from "vue-router";
import HomePage from "@/views/HomePage.vue";
import ServiceDetail from "@/views/ServiceDetail.vue";
import SolutionDetail from "@/views/SolutionDetail.vue";
import ProductServiceDetail from "@/views/ProductServiceDetail.vue";
import CustomerCases from "@/views/CustomerCases.vue";
import AboutUs from "@/views/AboutUs.vue";

const router = createRouter({
  // 和 vue.config.js 的 publicPath: '/test' 统一
  history: createWebHistory('/test'), 
  routes: [
    { path: "/", name: "home", component: HomePage },
    { path: "/service", name: "service", component: ServiceDetail },
    { path: "/solution", name: "solution", component: SolutionDetail },
    { path: "/productService", name: "productService", component: ProductServiceDetail },
    { path: "/CustomerCases", name: "CustomerCases", component: CustomerCases },
    { path: "/AboutUs", name: "AboutUs", component: AboutUs },
  ],
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) return savedPosition;
    if (to.hash) {
      return { el: to.hash, top: 72, behavior: "smooth" };
    }
    return { top: 0 };
  },
});

// 新增：强制首次加载跳转到首页（兜底）
router.beforeEach((to, from, next) => {
  // 首次进入（from.path 为空）且目标路径是根路径时，强制确认跳转
  if (from.path === "" && to.path === "/") {
    next({ path: "/", replace: true });
  } else {
    next();
  }
});

export default router;